export default __webpack_public_path__ + "static/media/amazon-ecs-icon.459e415c.svg";